import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_component_Icon, {
    class: "pointer",
    stroke: $props.favorite ? 'var(--brand-500)' : 'var(--gray-500)',
    fill: $props.favorite ? 'var(--brand-500)' : 'transparent',
    width: $props.size,
    height: $props.size,
    "stroke-width": "1",
    icon: "bookmark"
  }, null, 8 /* PROPS */, ["stroke", "fill", "width", "height"]))
}